export const selectEmployeeData = (state) =>
  state.employee?.employees || [];

export const selectEmployeeMeta = (state) =>
  state.employee?.meta || {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 5,
  };

export const selectEmployeeStatus = (state) =>
  state.employee?.loading || false;

export const selectEmployeeError = (state) =>
  state.employee?.error || null;

export const selectSelectedEmployee = (state) =>
  state.employee?.selectedEmployee || null;